export const METRICS = {
  EXECUTOR: 'executor',
  EVENT: {
    REGISTER: 'registro',
    SUCCESS_REGISTER: 'registro exitoso',
  },
  CATEGORY: {
    LANDING: 'landing',
  },
  ACTION: {
    REGISTER: 'registro',
    REGISTER_TELMEX: 'registro telmex',
  },
  LABEL: {
    SING_UP: 'registrate',
    LOG_IN: 'inicia sesion',
    FREE_WATCH: 'ver gratis',
    CODE_ACTIVE: 'activar codigo promocional',
    COUNTRY: 'seleccion pais - ',
    TERMS: 'terminos y condiciones',
    TERMS_BACK: 'terminos y condiciones - volver',
    TERMS_ACCEPT: 'aceptar terminos y condiciones',
    PROMOTIONS: 'conoce las promociones',
    PROMOTIONS_OK: 'conoce las promociones - entendido',
    EMAIL_NEXT: 'correo - siguiente',
    EMAIL_CANCEL: 'correo - cancelar',
    EMAIL_PASSWORD_NEXT: 'correo - Ingresar contraseña - siguiente',
    EMAIL_PASSWORD_CANCEL: 'correo - Ingresar contraseña - cancelar',
    EMAIL_SUCCESS: 'exitoso - correo',
    OPERATOR_RESEND: 'operadora - reenviar codigo',
    OPERATOR_NEXT: 'operadora - codigo - siguiente',
    OPERATOR_CANCEL: 'operadora - codigo - cancelar',
    CODE_NEXT: 'codigo promocional - siguiente',
    CODE_CANCEL: 'codigo promocional - cancelar',
  },
};
